import Vue from 'vue';
import  matomo from '@/utils/matomo'

Vue.directive('pad', (el) => {
    if (el.children.length <= 0) {
        el.innerHTML = '<div style="width: 100%;height: 1px;"></div>';
    }
});

Vue.directive('watermark',(el,binding)=>{

    var canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 200;
    var context = canvas.getContext('2d');
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillStyle = 'transparent';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.font = "12px Arial";
    context.fillStyle = "#ADADAD";
    context.textAlign = "center";
    context.save();
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(-Math.PI/8);
    var value = binding.value||{};
    context.fillText(value.text, 0,0);

    var dataUrl = canvas.toDataURL();





    let markNode = el.querySelector('.jt-water-mark');
    if(!markNode){
        let markHtml = document.createElement("div");
        markHtml.className = 'jt-water-mark';
        el.appendChild(markHtml);
        markNode = el.querySelector('.jt-water-mark');
    }

    let markNode1 = el.querySelector('.jt-water-mark1');
    if(!markNode1){
        let markHtml1 = document.createElement("div");
        markHtml1.className = 'jt-water-mark1';
        el.appendChild(markHtml1);
        markNode1 = el.querySelector('.jt-water-mark1');
    }
    // let value = binding.value||{};
    // markNode.innerHTML = new Array(1000).fill('<span class="jt-water-mark-text">'+value.text+'</span>').join('');

    markNode.style.background = "url("+dataUrl+")";
    markNode1.style.background = "url("+dataUrl+")";
});


Vue.directive('label',{
    bind(el, binding) {
        let value = binding.value||{};
        let text = value.title||'';
        let color = value.color||'';
        let classList = Array.from(el.classList);
        if(!classList.includes('relative')){
            el.classList.add('relative');
        }
        let spanHtml = document.createElement("span");
        spanHtml.className = 'jt-form-element-label';
        spanHtml.innerText = text;
        spanHtml.style="line-height:14px;font-size:12px;background-color:#fff;color:"+color+";position: absolute;left: 10px;top: -11px;z-index: 2;padding:0 5px;border-radius:3px;";
        el.appendChild(spanHtml);
    },
});
/**
 * 权限指令： 用法 v-permission="['export']" 可传多个
 * 注意：  引入 pageMixin 或者 定义 componentName = 'PagePermissionName' 和 pageFuncNames 权限列表
 */
Vue.directive('permission', {
    inserted(el, binding, vnode) {
        var parent = vnode.context.$parent;
        var name = parent.$options.componentName;
        while (parent && (!name || name !== 'PagePermissionName')) {
            parent = parent.$parent;
            if (parent) {
                name = parent.$options.componentName;
            }
        }
        if (parent) {
            // pageFuncNames HTMLElement
            const span = document.createElement('span');
            span.setAttribute('visibility', 'hidden');
            const unwatch = parent.$watch('pageFuncNames', (n)=> {
                const permissionList = parent.pageFuncNames;
                 // console.log(permissionList);
                const list = binding.value;
                if (Array.isArray(list)) {
                    const hasPermission = list.some(permission=> permissionList.includes(permission));
                    if (!hasPermission) {
                        el.replaceWith(span)
                    }else {
                        span.replaceWith(el)
                    }
                }else {
                    console.error("请传入数组：如['add']");
                }
            }, {
                immediate: true
            });
            el.__VUE_WATCH_FN__ = ()=>unwatch();
        }else {
            return;
        };
    },
    unbind(el) {
        const FN = el.__VUE_WATCH_FN__;
        FN&&FN();
    }
})


Vue.directive('matomo', {
    inserted(el, binding, vnode) {
        el.onclick = function(){
            const { behaviorCategory, event = '点击', name, value } = el._VALUE || binding.value;
            console.log(`${behaviorCategory}-${event}-${name}`);
            matomo.trackEvent(behaviorCategory, event, name, JSON.stringify(value));
        }
    },
    update(el, binding, vnode) {
        el._VALUE = binding.value;
    },
    unbind(el) {
       
    }
})

